import request from '@/utils/request'

/** 概览：群列表 + 开关状态 + 还有几所学校没配群 */
export function getNoticeGroupOverview() {
  return request({
    url: '/admin/notice-group/overview',
    method: 'get'
  })
}

export function createNoticeGroup(data) {
  return request({
    url: '/admin/notice-group',
    method: 'post',
    data
  })
}

export function updateNoticeGroup(data) {
  return request({
    url: '/admin/notice-group',
    method: 'put',
    data
  })
}

export function toggleNoticeGroup(id) {
  return request({
    url: `/admin/notice-group/${id}/toggle`,
    method: 'post'
  })
}

export function deleteNoticeGroup(id) {
  return request({
    url: `/admin/notice-group/${id}`,
    method: 'delete'
  })
}

/**
 * 发送测试消息。
 * 传 id 测已保存的群；不传 id 但带 webhookUrl 可以"先测再存"。
 */
export function testNoticeGroup(data) {
  return request({
    url: '/admin/notice-group/test',
    method: 'post',
    data,
    // 发消息要等钉钉响应，默认超时会误报失败
    timeout: 15000
  })
}
